import { useRef, useEffect, useState } from 'react';

function useInView() {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return { ref, inView };
}

export default function MidPageCTA() {
  const { ref, inView } = useInView();
  const scrollToContact = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-28 overflow-hidden" ref={ref}>
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4296daea8d6ea19fffc6e2f772c8fe5d.jpg"
          alt="Legal consultation — Gamble & Garcia Attorneys at Law"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#0A0A0A]/88"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/70 via-transparent to-[#0A0A0A]/70"></div>
      </div>
      {/* Gold accent lines */}
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#C9A84C] to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#C9A84C] to-transparent"></div>

      <div className={`relative z-10 max-w-[860px] mx-auto px-6 md:px-12 text-center transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="flex items-center justify-center gap-4 mb-7">
          <div className="w-12 h-[1px] bg-[#C9A84C]/50"></div>
          <span className="text-[#C9A84C] text-[10px] tracking-[0.5em] uppercase font-medium">Get Started Today</span>
          <div className="w-12 h-[1px] bg-[#C9A84C]/50"></div>
        </div>
        <h2 className="font-serif text-white text-4xl md:text-5xl font-bold mb-5 leading-tight">
          Need Legal Guidance?
        </h2>
        <p className="text-white/55 text-xl mb-12 leading-relaxed">
          Speak directly with an attorney today — no obligation, no pressure.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={scrollToContact}
            className="px-10 py-4 bg-[#C9A84C] text-black font-bold text-[11px] tracking-[0.28em] uppercase hover:bg-[#b8943e] transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ paddingTop: '18px', paddingBottom: '18px' }}
          >
            Speak With an Attorney Today
          </button>
          <a
            href="tel:8059228308"
            className="px-10 py-4 border-2 border-white/45 text-white font-bold text-[11px] tracking-[0.28em] uppercase hover:bg-white hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2.5"
            style={{ paddingTop: '18px', paddingBottom: '18px' }}
          >
            <i className="ri-phone-fill text-sm"></i>
            (805) 922-8308
          </a>
        </div>
      </div>
    </section>
  );
}
